const ValuationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    fill="none"
    {...props}
  >
    <path
      fill="#00bc93"
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H59.08A6.919 6.919 0 0 1 66 6.919V59.08A6.919 6.919 0 0 1 59.081 66H6.92A6.919 6.919 0 0 1 0 59.081V6.92Z"
    />
    <path
      fill="#fff"
      fillOpacity={0.9}
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H59.08A6.919 6.919 0 0 1 66 6.919V59.08A6.919 6.919 0 0 1 59.081 66H6.92A6.919 6.919 0 0 1 0 59.081V6.92Z"
    />
    <path
      fill="#00bc93"
      fillRule="evenodd"
      d="M48.75 48.75v-31.5h-31.5v31.5h31.5Zm-2.625-2.625V34.312H34.312v11.813h11.813Zm0-26.25v11.813H34.312V19.874h11.813Zm-14.438 0v11.813H19.876V19.874h11.813Zm-11.812 26.25V34.312h11.813v11.813H19.874Zm24.063-9.188H36.5v2.626h7.438v-2.626Zm0 4.376H36.5v2.624h7.438v-2.624ZM41.53 22.28v2.407h2.407v2.625H41.53v2.406h-2.625v-2.407H36.5v-2.625h2.406v-2.406h2.625ZM23.92 36.725l1.701 1.702 1.702-1.702 1.856 1.856-1.702 1.702 1.702 1.701-1.856 1.856-1.702-1.701-1.701 1.701-1.857-1.856 1.702-1.701-1.701-1.702 1.856-1.856ZM29.5 24.47h-7.438v2.625H29.5v-2.625Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillOpacity={0.4}
      fillRule="evenodd"
      d="M48.75 48.75v-31.5h-31.5v31.5h31.5Zm-2.625-2.625V34.312H34.312v11.813h11.813Zm0-26.25v11.813H34.312V19.874h11.813Zm-14.438 0v11.813H19.876V19.874h11.813Zm-11.812 26.25V34.312h11.813v11.813H19.874Zm24.063-9.188H36.5v2.626h7.438v-2.626Zm0 4.376H36.5v2.624h7.438v-2.624ZM41.53 22.28v2.407h2.407v2.625H41.53v2.406h-2.625v-2.407H36.5v-2.625h2.406v-2.406h2.625ZM23.92 36.725l1.701 1.702 1.702-1.702 1.856 1.856-1.702 1.702 1.702 1.701-1.856 1.856-1.702-1.701-1.701 1.701-1.857-1.856 1.702-1.701-1.701-1.702 1.856-1.856ZM29.5 24.47h-7.438v2.625H29.5v-2.625Z"
      clipRule="evenodd"
    />
  </svg>
);
export default ValuationIcon;
